import { TextField } from '@material-ui/core';
import cn from 'classnames';
import { FormikErrors, FormikTouched } from 'formik';
import { Dispatch, forwardRef, SetStateAction } from 'react';
import HidePassword from 'shared/components/form/hidePassword';
import InputError from 'shared/components/form/inputError';
import './styles.scss';

interface InputTextProps {
	label: string;
	isFieldValueValid: (field: string, errors: any, touched: {}) => boolean;
	errors: FormikErrors<{ [field: string]: any }>;
	touched: FormikTouched<{}>;
	onBlur: any;
	setFieldValue: (field: string, val: any) => void;
	name: string;
	autoFocus?: boolean;
	onChange?: (e: any) => void;
	values: any;
	additionalError?: string;
	type?: string | 'text';
	description?: string | '';
	required?: boolean;
	formatValue?: string;
	autoComplete?: string;
	setPasswordInputType?: Dispatch<SetStateAction<'text' | 'password'>>;
	passwordInputType?: string;
	isPasswordInput?: boolean;
	placeholder?: string;
	shrinkInput?: boolean;
	inputProps?: any;
	inputRef?: any;
	warnings?: string;
	multiline?: boolean;
	minRows?: number;
	className?: string;
	disabled?: boolean;
	cyTestRef?: string;
	cyErrorRef?: string;
	cyDescriptionTestRef?: string;
	backgroundColor?: 'green' | 'grey' | 'white';
	onPaste?: any;
}

const InputText = forwardRef(function Transition(
	{
		name,
		label,
		isFieldValueValid,
		errors,
		touched,
		onBlur,
		autoFocus,
		setFieldValue,
		onChange,
		values,
		additionalError,
		type,
		description,
		formatValue,
		autoComplete = 'off',
		setPasswordInputType = () => {},
		passwordInputType = 'password',
		isPasswordInput = false,
		placeholder,
		required,
		shrinkInput,
		inputProps,
		warnings,
		inputRef,
		multiline,
		minRows,
		disabled,
		cyTestRef,
		cyErrorRef,
		onPaste,
		cyDescriptionTestRef,
		backgroundColor = 'green',
	}: InputTextProps & { children?: React.ReactElement<any, any> },
	ref?: any,
) {
	const isError = isFieldValueValid(name, errors, touched);
	const value = formatValue ? formatValue : values[name];

	return (
		<>
			<div className="inputText">
				<div
					className={cn('inputText__container', {
						'inputText__container--green': backgroundColor === 'green',
						'inputText__container--grey': backgroundColor === 'grey',
						'inputText__container--white': backgroundColor === 'white',
						'inputText__container--error': isError || additionalError,
						'inputText__container--warning': !isError && !additionalError && warnings,
					})}
				>
					<TextField
						inputRef={inputRef}
						autoComplete={autoComplete}
						onPaste={onPaste}
						variant="filled"
						InputLabelProps={{ shrink: shrinkInput }}
						label={label}
						autoFocus={autoFocus}
						placeholder={placeholder}
						type={type}
						required={required || false}
						name={name}
						value={value}
						onBlur={onBlur}
						inputProps={{ ...inputProps, 'data-cy': cyTestRef }}
						onChange={onChange ? onChange : (e: any) => setFieldValue(e.target.name, e.target.value)}
						multiline={multiline}
						minRows={minRows}
						disabled={disabled}
					/>
					{isPasswordInput && (
						<HidePassword
							onClick={() => {
								setPasswordInputType(passwordInputType === 'password' ? 'text' : 'password');
							}}
							inputType={passwordInputType}
							whiteIcon={backgroundColor === 'green'}
						/>
					)}
				</div>
				<InputError
					warnings={warnings}
					additionalError={additionalError}
					isError={isError}
					name={name}
					errors={errors}
					cyErrorRef={cyErrorRef}
				/>
			</div>
			{description && (
				<div className="inputText__description" data-cy={cyDescriptionTestRef}>
					{description}
				</div>
			)}
		</>
	);
});

export default InputText;
